import { giphyDarkestGrey } from '@giphy/js-brand'
import { omit } from 'lodash'
import React, { useEffect } from 'react'
import { useKeyPress } from 'react-use'
import DotsLoader from 'shared/components/loaders/dots'
import styled from 'styled-components'
import Editor, { SourceEditorProps } from '.'
import { BORDER_RADIUS_MEDIUM } from '../../constants'
import { OverlayBlock } from '../blocks'
import { ToolButton } from '../buttons'

const Modal = styled.div`
    height: 100%;
    left: 0;
    overflow: auto;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 500;
`

const Dim = styled(OverlayBlock)`
    background: rgba(0, 0, 0, 0.9);
    position: fixed;
`

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    margin: 75px auto 0;
    position: relative;
    width: 1040px;
`

const CloseButton = styled(ToolButton)`
    background: ${giphyDarkestGrey};
    border-radius: ${BORDER_RADIUS_MEDIUM}px;
    color: #fff;
    font-size: 20px;
    height: 50px;
    line-height: 54px;
    text-align: center;
    width: 50px;
`

interface Props extends SourceEditorProps {
    isLoading?: boolean
    onCancel: () => void
}

const CreationToolsSourceEditorModal = (props: Props) => {
    const [isEscPressed] = useKeyPress((e: KeyboardEvent) => e.keyCode === 27)
    const { onCancel } = props
    const editorProps: SourceEditorProps = omit(props, ['onCancel'])

    useEffect(() => {
        // disable body scrolling
        document.body.style.overflow = 'hidden'

        return () => {
            // re-enable body scrolling
            document.body.style.overflow = ''
        }
    }, [])

    useEffect(() => {
        if (isEscPressed) {
            onCancel()
        }
    }, [onCancel, isEscPressed])

    const onCloseClick = () => {
        onCancel()
    }

    return (
        <Modal>
            <Dim onClick={onCloseClick} />
            <Wrapper style={props.isLoading ? { visibility: 'hidden' } : undefined}>
                <Editor {...editorProps}>
                    <CloseButton className="ss-delete" onClick={onCloseClick} />
                </Editor>
            </Wrapper>
            {props.isLoading && <DotsLoader isAbsolute />}
        </Modal>
    )
}

export default CreationToolsSourceEditorModal
